import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import { saveReadingByReadingId, getReadingByReadingId } from '../services/ReadingPublicService';

export const useReadingPublicSaveReadingByReadingId = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(saveReadingByReadingId, 'requestBody', 'data'),
      'data',
      'readingId',
      'houseNumber',
      'meters',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['readingId', 'houseNumber', 'meters'] },
    ],
  },
);

export const useReadingPublicGetReadingByReadingId = createDCHook(
  'getReadingByReadingId',
  collapseDataFromCall(getReadingByReadingId),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);
